import { createContextFactory } from '@streem/toolbox';
export const [GroupsProvider, useGroups] = createContextFactory('Groups');
//# sourceMappingURL=groups.js.map